// import i18n, { getLanguage } from '@/lang'
import Cookies from 'js-cookie'
// import axios from '@/axios'

// 要设置的全局访问的state对象
const state = {
  language: Cookies.get('language') || 'zh_CN', // 中英文
  menuTitle: Cookies.get('menuTitle') || 'home', // 当前菜单key
  token: Cookies.get('token') || '', // 用户token
  account: Cookies.get('account') || '', // 用户account
  roleCode: Cookies.get('roleCode') || '', // 用户roleCode
  isAdmin: Cookies.get('isAdmin') || '', // 用户是否是admin
  isOthers: Cookies.get('isOthers') || '', // 用户是否是others
  isHead: Cookies.get('isHead') || '', // 用户是否是HEADQUARTER
  areaList: [], // 区域列表
  provinceList: [], // 省份列表
  cityList: [], // 城市列表
  resellerList: [], // 客户列表
  subResellerList: [], // 二级客户列表
  KeyDoorList: [], // iskeydoor列表
  courseClassList: [], // 品类列表
  roleList: [], // 角色列表
  statusList: [] // 状态列表
}

// 处理同步
const mutations = {
  setToken (state, token) {
    state.token = token
    Cookies.set('token', token)
  },
  setAccount (state, account) {
    /* state.account = account
    Cookies.set('account', account) */
  },
  setRoleCode (state, roleCode) {
    state.roleCode = roleCode
    Cookies.set('roleCode', roleCode)
  },
  setLanguage (state, lang) {
    state.language = lang
    Cookies.set('language', lang)
  },
  setAdmin (state, bool) {
    state.isAdmin = bool
    Cookies.set('isAdmin', bool)
  },
  setOthers (state, bool) {
    state.isOthers = bool
    Cookies.set('isOthers', bool)
  },
  setHead (state, bool) {
    state.isHead = bool
    Cookies.set('isHead', bool)
  },
}

// 处理异步
const actions = {
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/openSurvey/store/modules/app.js